import { render, staticRenderFns } from "./FCM.vue?vue&type=template&id=1ec69f4c&lang=pug"
import script from "./FCM.vue?vue&type=script&lang=js"
export * from "./FCM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports